
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Divider from 'vux/src/components/divider/index.vue'
import XTable from 'vux/src/components/x-table/index.vue'


export default {
components: {
Group,
Cell,
XButton,
XInput,
Divider,
XTable,
},
methods: {
get_wxid_history(wxid) {
let that = this;
if (wxid == "") return;
var code_url = "/api/v1/get_wxid_history/" + wxid;
that.$http.post(code_url).then((ret) => {
if (ret.data.history.length > 0) {
var hisDatas = ret.data.history.split("|");
for (var item of hisDatas) {
if (item.indexOf(",") > -1) {
var single = item.split(",");
var newData = {
time: single[0],
gap: single[1],
dh: single[2],
dh1: single[3],
location: single[4],
};

that.history_data.push(newData);
}
}
}
});
},
init() {
let that = this;
let Base64 = require("js-base64").Base64;
console.log(location.href);
let urlArgs = location.href.split("#")[0];
console.log(urlArgs);
let urlBase64 = Base64.encode(urlArgs);
console.log(urlBase64);

let urlEncode = encodeURIComponent(urlBase64);

console.log(urlEncode);

var url = "/api/v1/get_wx_config/" + urlEncode;

that.$http.post(url).then((ret) => {
console.log(JSON.stringify(ret));
that.$wechat.config(ret.data);

that.wx_id = that.$cookies.get("wx_id");
if (
that.wx_id == undefined ||
that.wx_id == null ||
that.wx_id == "" ||
that.wx_id == "null" ||
that.wx_id == "undefined"
) {
var code = that.getQueryValue("code");
var code_url = "/api/v1/get_page_token/" + code;
that.$http.post(code_url).then((ret) => {
console.log(JSON.stringify(ret.data));

if (ret.data.openid != "") {
that.wx_id = ret.data.openid;
that.$cookies.set("wx_id", that.wx_id);
that.disabled = true;

that.get_wxid_history(that.wx_id);
} else {
that.error = true;
that.disabled = false;
}
});
} else {
that.disabled = true;
that.get_wxid_history(that.wx_id);
}
});
},
getQueryValue(queryName) {
var query = decodeURIComponent(window.location.href.split("?")[1]);
var vars = query.split("&");
for (var i = 0; i < vars.length; i++) {
var pair = vars[i].split("=");
if (pair[0] == queryName) {
return pair[1];
}
}
return null;
},
post_scan_data(result, wx_id) {
let that = this;
let Base64 = require("js-base64").Base64;
var url = "/api/v1/scan_qr/" + Base64.encode(result + "," + wx_id);
that.$http.post(url).then((ret) => {
console.log(JSON.stringify(ret));
if (ret.data.code == 0) {
that.$vux.alert.show({
title: "扫码称重",
content: "扫码成功，请等待开启。",
onShow() {


},

});
} else {
that.$vux.alert.show({
title: "扫码失败",
content: ret.data.message,
onShow() {},
onHide() {


that.router.push("/CheckId");
},
});
}
});
},
startScan() {
let that = this;
let Base64 = require("js-base64").Base64;
that.$wechat.scanQRCode({
needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
scanType: ["qrCode", "barCode"], // 可以指定扫二维码还是一维码，默认二者都有
success: function (res) {
that.scan_result = res.resultStr; 
that.post_scan_data(that.scan_result, that.$cookies.get("wx_id"));
},
});
},
},
mounted() {
let that = this;
that.init();
},
data() {
return {
history_data: [],
wx_id: "",
disabled: false,
phone: "",
plate_no: "",
scan_result: "",
scan_failed: 0,
error: false,
};
},
};



// WEBPACK FOOTER //
// ./src/components/ScanQR.vue